var map = {
	"./1-Fuerstenberg-klein.jpg": 84,
	"./2-Kruzifixus-Erp-klein.jpg": 85,
	"./3-Nachtlandschaft-klein.jpg": 86,
	"./4-Hl-Barbara-klein.jpg": 87,
	"./5-Halterung-Servatius-klein.jpg": 88,
	"./6 Servatius-Schatzkammer-bearb.jpg": 89
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 271;